import { useCallback, useEffect } from 'react';
import { useParams, useLocation } from 'react-router';
import { Page, useNavigation } from '@bonanza-social/navigation';
import { Box, useBreakpointProp } from '@bonanza-social/moonlight';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { launchGame } from '../state/games/games.slice';
import Gameplay from '../components/Gameplay/Gameplay';
import { DeviceType } from '../index.types';

function GameLaunchPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigation = useNavigation();
  const { id, currencyCode: currencyCodeParam } = useParams();
  const deviceType = useBreakpointProp<DeviceType>({
    mobile: 'mobile',
    tablet: 'mobile',
    desktop: 'desktop',
  });
  const { eligible } = location.state || {};
  const currencyCode = currencyCodeParam?.toUpperCase();

  const onGameExit = useCallback(() => {
    // navigation.popToTop();
  }, []);

  useEffect(() => {
    // The game launch page is opened via a URL
    if (eligible === undefined) {
      const gameId = id ?? '';
      dispatch(
        launchGame({
          id: gameId,
          currencyCode,
          onError: () => navigation.navigate('Home'),
        }),
      );
    }
  }, [id, eligible, currencyCode, navigation, dispatch]);

  return (
    <Page>
      <Box flex={1}>
        {eligible && (
          <Gameplay
            id={Number(id)}
            deviceType={deviceType}
            currencyCode={currencyCode}
            onExit={onGameExit}
          />
        )}
      </Box>
    </Page>
  );
}

export default GameLaunchPage;
